import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=609190d3&scoped=true&"
import script from "./Reference.vue?vue&type=script&lang=js&"
export * from "./Reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609190d3",
  null
  
)

export default component.exports